import { StatusBadgeProps } from './StatusBadge.types';
import { Badge } from '@fluentui/react-components';
import { StatusText } from './StatusBadge.styled';
import { ticketStatusCodeLookUp } from 'src/components/Tickets/MyTickets.constants';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useContext, useMemo } from 'react';

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const { themeString } = useContext(TeamsFxContext);

  const { cssStyles, BadgeIcon } = useMemo(() => {
    const modeStyles = themeString === 'dark' ? 'darkMode' : 'lightMode';
    const _cssStyles =
      ticketStatusCodeLookUp[status]?.badgeComponentOptions?.css[modeStyles];

    const _BadgeIcon =
      status && ticketStatusCodeLookUp[status]?.badgeComponentOptions?.icon;

    return { cssStyles: _cssStyles, BadgeIcon: _BadgeIcon };
  }, [themeString, status]);

  return (
    <>
      {status && (
        <Badge
          size="large"
          style={{
            background: cssStyles?.backgroundColor,
            border: cssStyles?.boarderColor,
          }}
          icon={
            status && (
              <BadgeIcon
                style={{
                  color: cssStyles?.iconColor,
                }}
              />
            )
          }
        >
          <StatusText style={{ color: cssStyles?.labelColor }}>
            {ticketStatusCodeLookUp[status].label}
          </StatusText>
        </Badge>
      )}
    </>
  );
};
